import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  STATUS_PROCESS,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENGAJUAN,
  urlChangeStatus,
  urlCreatePO,
  urlUpdatePO,
} from "../../helpers";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "green",
  state: false,
};

export const SHOW_PROCESS = {
  label: "PROCESSS",
  color: "warning",
  state: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: false,
};

const ModalSimpan = ({ setShowModal, resetForm, setNewDataPoList }) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);

  const { formData, setFormData } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.date) || isNull(formData.gudang_id) || isNull(formData.supplier_id)  || isNull(formData.penerima)) {
        defaultToastError("Harap melengkapi semua data pada form!");
        setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      } else {
        const api = await instance4.post(urlCreatePO, {
          date: toUTCFormat(formData.date),
          gudang_id: formData.gudang_id,
          supplier_id: formData.supplier_id,
          penerima: formData.penerima,
          catatan: formData.remark,
          namaPO: "",
          tax: formData.tax,
          potongan: formData.potongan,
          status_transaksi: STATUS_TRANSAKSI_PENGAJUAN,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            idpo: res.po_id,
            isOpenDraf: true,
            isProcess: false,
          });

          setNewDataPoList(res.po_id);
        } else {
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          defaultToastError(res?.message);
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickProcess = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledProcess(SHOW_PROCESS);
      } else {
        const api = await instance4.post(urlChangeStatus, {
          id: formData.idpo,
          status: STATUS_PROCESS,
          status_transaksi: STATUS_TRANSAKSI_DISETUJUI,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setDisabledProcess(SHOW_PROCESS);
          setFormData({
            ...formData,
            isProcess: true,
          });
        } else {
          defaultToastError(res?.message);
          setDisabledProcess(SHOW_PROCESS);
        }
        // resetForm();
      }
    } catch (error) {
      setDisabledProcess(SHOW_PROCESS);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdatePO, {
          id: formData.idpo,
          date: formData.date,
          gudang_id: formData.gudang_id,
          supplier_id: formData.supplier_id,
          penerima: formData.penerima,
          catatan: formData.remark,
          namaPO: "",
          tax: formData.tax,
          potongan: formData.potongan,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setNewDataPoList(formData.idpo);
        } else {
          setDisabledUpdate(SHOW_UPDATE);
          defaultToastError(res?.message);
        }
        // resetForm();
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{
          marginBottom: "1rem",
        }}>
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          disabledOpenDraft={disabledOpenDraft}
          handleClickOpenDraf={handleClickOpenDraf}
          disabledProcess={disabledProcess}
          handleClickProcess={handleClickProcess}
          disabledUpdate={disabledUpdate}
          handleClickUpdate={handleClickUpdate}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  disabledOpenDraft,
  handleClickOpenDraf,
  disabledProcess,
  handleClickProcess,

  disabledUpdate,
  handleClickUpdate,
}) => {
  return (
    <>
      {isOpenDraf ? (
        <>
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            disabled={disabledProcess.state}
            color={disabledProcess.color}
            onClick={(e) => handleClickProcess(e)}
            name={disabledProcess.label}
            size='lg'
          />
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledUpdate.color}
            onClick={(e) => handleClickUpdate(e)}
            name={disabledUpdate.label}
            disabled={disabledUpdate.state}
            size='lg'
          />
        </>
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          disabled={disabledOpenDraft.state}
          onClick={(e) => handleClickOpenDraf(e)}
          size='lg'
        />
      )}
    </>
  );
};

export default ModalSimpan;
